module.exports = require('./TaskReassignModalView');
